import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'src/app/providers/services/alerts.service';
import { ParticipantsService } from 'src/app/providers/services/participants.service';
import { IParticipant } from 'src/app/storage/interfaces/participant.interface';

@Component({
    selector: 'app-create-participant',
    templateUrl: './create-participant.component.html',
    styleUrls: ['./create-participant.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateParticipantComponent implements OnInit {

  @Input() missionId: string;

  form: UntypedFormGroup;
  // refineryparticipantfunctions = [
  //   {refineryparticipantfunctionpk: 1, refineryparticipantfunction: 'process engineer'},
  //   {refineryparticipantfunctionpk: 2, refineryparticipantfunction: 'unit manager'},
  //   {refineryparticipantfunctionpk: 3, refineryparticipantfunction: 'pilot of the sulfiding reaction'},
  //   {refineryparticipantfunctionpk: -1, refineryparticipantfunction: 'other or unknown'},
  // ]

  @Output() closeModal = new EventEmitter<any>();
  @Output() reloadList = new EventEmitter<any>();


  constructor(
    private participantsService: ParticipantsService,
    private alertsService: AlertsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.form = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required]),
      lastName: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required]),
      // role: new FormControl('', [Validators.required]),
    });
  }

  close(): void {
    this.closeModal.emit();
  }

  async create() {
    const participant = JSON.parse(JSON.stringify(this.form.value));
    this.form.reset();

    await this.insertParticipant(participant, this.missionId);
  }

  private async insertParticipant(participant: IParticipant, missionId) {
    try {
      await this.participantsService.insertParticipant(participant, missionId);
      this.alertsService.success({
        title: "Attendee created",
        content: "The attendee has been created successfully."
      });
      this.reloadList.emit();

    } catch (_) {
      this.alertsService.error({
        title: "Error creating attendee",
        content: "An error occurred while creating the attendee."
      });
    }
  }
}